export default __webpack_public_path__ + "static/media/property_689.d869a93a.png";